import Instance from '../../../utils/Axios';

const Perfis = () => async (dispatch) => {
  const stateToken = localStorage.token;

  if (stateToken) {
    await Instance()
      .get('/perfis')
      .then(({ data }) => {
        if (stateToken) {
          dispatch({ type: 'GET_PERFIS', payload: data.yData });
        }
      })
      .catch(({ err }) => console.log(err));
  }
};

export default Perfis;
